import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { toast } from 'sonner';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Loader2, CheckCircle, Calendar } from 'lucide-react';

const CompletedWork = () => {
  const [completedBooks, setCompletedBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompletedBooks();
  }, []);

  const fetchCompletedBooks = async () => {
    try {
      const response = await axios.get(`${API}/proofreader/completed-books`);
      setCompletedBooks(response.data);
    } catch (error) {
      toast.error('Kon nie voltooide boeke laai nie');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Voltooide Werk
        </h2>
        <p className="text-gray-600">Geskiedenis van boeke wat jy proefgelees het</p>
      </div>

      {completedBooks.length === 0 ? (
        <Card>
          <CardContent className="py-12">
            <div className="text-center text-gray-500">
              <CheckCircle className="h-12 w-12 mx-auto mb-3 text-gray-400" />
              <p>Jy het nog geen boeke voltooi nie</p>
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4">
          {completedBooks.map((book) => (
            <Card key={book.id} className="hover:shadow-md transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <h3 className="text-xl font-bold text-gray-900">{book.boek_naam}</h3>
                      <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 flex items-center gap-1">
                        <CheckCircle className="h-3 w-3" />
                        Voltooi
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                      <div>
                        <p className="text-gray-600 font-semibold">Skrywer:</p>
                        <p className="text-gray-900">{book.writer_name || 'Onbekend'}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 font-semibold">Genre:</p>
                        <p className="text-gray-900">{Array.isArray(book.genre) ? book.genre.join(', ') : book.genre}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 font-semibold">Woorde:</p>
                        <p className="text-gray-900">{book.word_count?.toLocaleString()}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 font-semibold">Bladsye:</p>
                        <p className="text-gray-900">{book.page_count}</p>
                      </div>
                    </div>

                    {book.fault_list_date && (
                      <div className="mt-3 flex items-center gap-2 text-sm text-gray-600">
                        <Calendar className="h-4 w-4" />
                        <span>Foute lys ingedien: {new Date(book.fault_list_date).toLocaleDateString('af-ZA')}</span>
                      </div>
                    )}

                    {book.current_status && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-500">
                          <strong>Huidige status:</strong> {book.current_status}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
        <p className="text-sm text-blue-800">
          <strong>Nota:</strong> Hierdie lys toon alle boeke waar jy 'n foute lys ingedien het. 
          Jy sal betaal word sodra die admin die betaling goedkeur.
        </p>
      </div>
    </div>
  );
};

export default CompletedWork;
